export interface cookieList {
	[key: string]: string;
}
export type CookieClearOpt = { domain?: string, path?: string, secure?: boolean, httpOnly?: boolean };
export type CookieOpt = { domain?: string, expire?: string, path?: string, secure?: boolean, httpOnly?: boolean };
export interface get {
	(name: string): string;
}
export interface set {
	(name: string, value: string, opt?: CookieOpt): void;
}
export interface clear {
	(name: string, opt?: CookieClearOpt): void;
	(opt?: CookieClearOpt): void;
}
export type getCookie = get;
export type setCookie = set;
export type clearCookie = clear;

//解析Cookie
function parseCookie(cookie: string): cookieList {
	if (typeof cookie !== 'string') { cookie = ''; }
	const cookies: string[] = cookie.replace(/\s/g, '').split(';');
	let cookieList = {};
	cookies.forEach(it => {
		let v = it.split('=');
		let name = decodeURIComponent(v.shift() as string);
		cookieList[name] = decodeURIComponent(v.join('='));
	})
	return cookieList;
}

export default  class Cookie {
	_newCookie: { name?: string, value?: string, expire?: string, domain?: string, path?: string, secure?: boolean, httpOnly?: boolean }[] = [];
	_oldCookie: cookieList;
	constructor(cookie: string) {
		this._oldCookie = parseCookie(cookie);
	}
	get(name: string): string {
		return name in this._oldCookie ? this._oldCookie[name] : '';
	};
	set(name: string, value: string, { expire, domain, path, secure, httpOnly }: CookieOpt = {}) {
		this._newCookie.push({ name, value, expire, domain, path, secure, httpOnly });
	};
	clear(name: string, opt?: CookieClearOpt): void;
	clear(opt?: CookieClearOpt): void;
	clear(name?: string | CookieClearOpt, opt?: CookieClearOpt) {
		let expire = 'Fri, 31 Dec 1999 16:00:00 GMT';
		if (name && typeof name === 'string') {
			const { domain, path, secure, httpOnly }: CookieClearOpt = opt || {}
			this._newCookie.push({ name, value: 'delete', expire, domain, path, secure, httpOnly });
		} else {
			const { domain, path, secure, httpOnly }: CookieClearOpt = (name as CookieClearOpt) || opt || {};
			this._newCookie = [];
			for (let name in this._oldCookie) {
				this._newCookie.push({ name, value: 'delete', expire, domain, path, secure, httpOnly });
			}
		}
	};
	get cookie() {
		return this._oldCookie;
	};
	get header() {
		return this._newCookie.map(({ name, value, expire, domain, path, secure, httpOnly }) => name ? [
			encodeURI(name) + '=' + encodeURI(value || ''),
			expire && 'Expires=' + expire,
			domain && 'Domain=' + encodeURI(domain),
			path && 'Path=' + encodeURI(path),
			secure && 'Secure',
			httpOnly && 'HttpOnly',
		].filter(Boolean).join('; ') : '').filter(Boolean);
	};
}
